import {
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { ReactNode } from 'react';

export interface DialogProps {
  open: boolean;
  onClose?: () => void;
  title: ReactNode;
  content: ReactNode;
  actions: ReactNode;
}

export const Dialog = ({ open, onClose, title, content, actions }: DialogProps) => (
  <MuiDialog open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{content}</DialogContentText>
    </DialogContent>
    <DialogActions>{actions}</DialogActions>
  </MuiDialog>
);
